import React, { ReactNode, createContext, useContext, useState } from "react";
import { Outlet } from "react-router-dom";

export type HoverContent = {
  question: string;
  chatQuestion: string;
  answer: string;
};

export interface NodeHoverContext {
  hoveredNodeContent: HoverContent;
  setHoveredNodeContent: (content: HoverContent) => void;
}

export const defaultNodeHoverContext: NodeHoverContext = {
  hoveredNodeContent: {
    question: "",
    chatQuestion: "",
    answer: "",
  },
  setHoveredNodeContent: () => null,
};

const NodeHoverContext = createContext<NodeHoverContext>(
  defaultNodeHoverContext
);

export const NodeHoverProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [hoveredNodeContent, setHoveredNodeContent] = useState<HoverContent>({
    question: "",
    chatQuestion: "",
    answer: "",
  });

  return (
    <NodeHoverContext.Provider
      value={{ hoveredNodeContent, setHoveredNodeContent }}
    >
      {children || <Outlet />}
    </NodeHoverContext.Provider>
  );
};

export const useNodeHover = (): NodeHoverContext => {
  const context = useContext(NodeHoverContext);
  if (!context) {
    throw new Error("useNodeHover must be used within a NodeHoverProvider");
  }
  return context;
};
